export default __webpack_public_path__ + "static/media/card1@3x.7bf6178a.png";